<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Gifts Reports</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Marketing</b> /
      <b>Gifts Reports</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    
    <form @submit.prevent="handleFilter">
      <div class="row ml-2">
        <label class="mr-4"><b>Show: </b></label>
          <div class="row">
            <label class="radio radio-gold ml-3">
                <input type="radio" name="activeStatus" v-model="data.type" v-bind:value="a">
                <span>Birthday</span>
                <span class="checkmark"></span>
            </label>
            <label class="radio radio-gold ml-3">
                <input type="radio" name="activeStatus" v-model="data.type"  v-bind:value="b">
                <span>Selected At</span>
                <span class="checkmark"></span>
            </label>
          </div>
      </div>
  
      <div class="d-flex flex-row mb-4">
        <div class="mr-2">
          <select class="form-control" v-model="data.month" required>
            <option v-for="month in months" :key="month.value" :value="month.value">{{ month.name }}</option>
          </select>
        </div>
        <div class="ml-2">
          <input type="number" class="form-control" v-model="data.year" required />
        </div>
  
        <div class="ml-4">
          <button type="submit" class="btn btn-primary rounded-3">Filter</button>
        </div>
      </div>
    </form>

    <div class="row mb-4">
      <div class="col-lg-6 col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <ChartComponent :data="generalChart" :chartOptions="chartOptions" :table_name="'tbl_gifts'" :table_data="general_data" :page_title="'General'" />
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <ChartComponent :data="tierData" :chartOptions="columnOptions" :table_name="'tbl_gifts2'" :table_data="tier_data" :page_title="'Tiers'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { GChart } from "vue-google-charts";
import ChartComponent from "./general.vue";
import { getStatisticData } from "../../../../services/GiftServices";

export default {
  components: {
    GChart,
    ChartComponent
  },

  data() {
    return {
      // gen: [["gift","Black","Platinum", "Gold", "Silver"],["Takaful Birthday Points",482,421,301,213],["Coffee Bean",103,89,74,23],["Hua Ho $5 Voucher",313,267,0,0],["Lane Microbakery & Coffee",13,21,0,0]],

      // tie: [["Gift","Total", {"role": 'style' }],["Takaful Birthday Points",1303, '#1f77b4'],["Coffee Bean",293, "#ff7f0e"],["Hua Ho $5 Voucher",580, "#2ca02c"],["Lane Microbakery & Coffee",34, "#d62728"]],

      tierData: [],
      generalChart: [],

      columnOptions: {
        title: "",
        height: 600,
        legend: "bottom"
      },

      chartOptions: {
        title: "",
        height: 600,
        legend: "none",
        vAxis: {
          minValue: 10
        },
      },

      months: [
        {value: 1, name: 'January'},
        {value: 2, name: 'February'},
        {value: 3, name: 'March'},
        {value: 4, name: 'April'},
        {value: 5, name: 'May'},
        {value: 6, name: 'June'},
        {value: 7, name: 'July'},
        {value: 8, name: 'August'},
        {value: 9, name: 'September'},
        {value: 10, name: 'October'},
        {value: 11, name: 'November'},
        {value: 12, name: 'December'},
      ],

      years: [
        '2018',
        '2019',
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
      ],

      data: {
        type: 1,
        month: 1,
        year: new Date().getFullYear()
      },

      a: 1,
      b: 2,

      general_data: [],
      tier_data: [],
      extraRequest: null,
    };
  },

  methods: {
    async fetchData(extraRequest = null) {
      try {
        const response = await getStatisticData(extraRequest);
        if(response.data.success) {
          this.generalChart = response.data.data.charts.general;
          this.tierData = response.data.data.charts.tier;

          this.general_data = response.data.data.tables.general;
          this.tier_data = response.data.data.tables.tier;
        }
      } catch (e) {
        console.log(e)
      }
    },

    async handleFilter() {
      this.extraRequest = null;

      try {
        this.extraRequest = `?type=${this.data.type}&year=${this.data.year}&month=${this.data.month}`;

        this.destroyDataTable('#tbl_gifts');
        this.destroyDataTable('#tbl_gifts2');

        await this.fetchData(this.extraRequest);

        this.loadTable("#tbl_gifts");
        this.loadTable("#tbl_gifts2");

      } catch (e) {
        console.error(e)
      }
    },

    destroyDataTable(name) {
      $(name).DataTable().destroy();
    },

    loadTable(name) {
      return $(name).DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4],
              columns: ':not(:last-child)',
            }
          },
          {
            extend: "pdfHtml5",
            orientation: 'landscape',
            pageSize: 'LEGAL',
            exportOptions: {
              columns: [0, 1, 2, 3, 4],
              columns: ':not(:last-child)',
            }
          }
        ]
      });
    },
  },

  async mounted() {
    await this.fetchData();
    this.loadTable("#tbl_gifts");
    this.loadTable("#tbl_gifts2");
  }
};
</script>
